import { useEffect } from 'react';

import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

const FULL_SCREEN_APP_DOWNLOAD_DESIGN_TEST_NAME = 'fullScreenAppDownloadDesign_May2026';
const APP_DOWNLOAD_COPY_TEST_NAME = 'appDownloadCopy_Sep2026';

function isFullScreenAppDownloadDesignTestVariant(): boolean {
    return getAbTestV2(FULL_SCREEN_APP_DOWNLOAD_DESIGN_TEST_NAME)?.variant === 'variant';
}

function trackFullScreenAppDownloadDesignAbTest(): void {
    trackAbTestV2Variant(FULL_SCREEN_APP_DOWNLOAD_DESIGN_TEST_NAME);
}

function isAppDownloadCopyTestVariant(): boolean {
    return getAbTestV2(APP_DOWNLOAD_COPY_TEST_NAME)?.variant === 'variant';
}

let isAppDownloadCopyTestTracked = false;

function useTrackAppDownloadCopyTest(options?: { skip?: boolean }): void {
    useEffect(() => {
        if (isAppDownloadCopyTestTracked || options?.skip) {
            return;
        }

        trackAbTestV2Variant(APP_DOWNLOAD_COPY_TEST_NAME);
        isAppDownloadCopyTestTracked = true;
    }, [options]);
}

export {
    isFullScreenAppDownloadDesignTestVariant,
    trackFullScreenAppDownloadDesignAbTest,
    isAppDownloadCopyTestVariant,
    useTrackAppDownloadCopyTest,
    APP_DOWNLOAD_COPY_TEST_NAME,
};
